module.exports = __webpack_public_path__ + "static/media/Streetlight.368339ae.svg";